import React, { useEffect, useState } from "react";
import { Link, useParams, useLocation  } from "react-router-dom";
import "../../Styles/Firstcard.css";
import "../../Styles/ViewFeeStructure.css"; 
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import ScaleLoader from "react-spinners/ScaleLoader";
import { Printer, AlertCircle } from 'lucide-react'; 
import html2pdf from 'html2pdf.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Firstcard({data}) {
 
  const [feeCategories, setFeeCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedClass, setSelectedClass] = useState(null);

  // ----------------------
  // NEW STATE FOR VIEW API
  // ----------------------
  const [gradeName, setGradeName] = useState("");
  const [academicName, setAcademicName] = useState("");
  const [summary, setSummary] = useState([]);

  const { yearID } = useParams();
  const { id } = useParams();
 

  const handleDownloadPDF = () => {
    const element = document.querySelector(".vfs-main-container"); 
    const opt = {
      margin: 10,
      filename: `Fee_Structure_${selectedClass.class_name}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
    };
    html2pdf().set(opt).from(element).save();
  };


  const handleFinalDelete = async () => {
  try {
    const requestBody = {
      customer_id: Number(localStorage.getItem("customer_id")) || 1005,
      api_key:
        localStorage.getItem("api_key") ||
        "b9359f494e77b6589ce12dd62518c585",
      
        academic: id || "cay25",
      user_id: Number(localStorage.getItem("user_id")) || 14857,
      language: "en",
      grade: selectedClass?.class_name || "ccs38"
    };

    const response = await simplePostCall(
      ApiConfig.deleteFeeStructure,
      JSON.stringify(requestBody)
    );

    if (response?.result) {
      toast.success("Successfully Deleted!", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });

      // Optional UX: go back to list view after delete
      setSelectedClass(null);
    } else {
      toast.error(response?.message || "Delete failed. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
    }
  } catch (error) {
    console.error("Delete Fee Structure Error:", error);
    toast.error("Something went wrong while deleting.", {
      position: "top-right",
      autoClose: 3000,
      theme: "colored",
    });
  }
};

  const confirmDelete = () => {
    toast(
      ({ closeToast }) => (
        <div style={{ padding: "10px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "15px" }}>
            <AlertCircle size={24} color="#e74c3c" />
            <span style={{ fontWeight: "600", color: "#333", fontSize: "15px" }}>
              Are you sure you want to delete this?
            </span>
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
            <button
              onClick={closeToast}
              style={{
                background: "#f1f1f1",
                color: "#333",
                border: "1px solid #ddd",
                padding: "6px 15px",
                borderRadius: "4px",
                cursor: "pointer",
                fontWeight: "500"
              }}
            >
              Cancel
            </button>
            <button
              onClick={() => {
                handleFinalDelete();
                closeToast();
              }}
              style={{
                background: "#e74c3c",
                color: "#fff",
                border: "none",
                padding: "6px 15px",
                borderRadius: "4px",
                cursor: "pointer",
                fontWeight: "500"
              }}
            >
              OK
            </button>
          </div>
        </div>
      ),
      {
        position: "top-center",
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        icon: false,
        style: { width: "350px", borderRadius: "8px" }
      }
    );
  };

 

  // ----------------------
  // LOAD CATEGORY LIST (UNCHANGED)
  // ----------------------
  useEffect(() => {
    loadDataStudentFee();
  }, [yearID]);

  const loadDataStudentFee = async () => {
    setIsLoading(true);
    const customer_id = localStorage.getItem("customer_id");
    const api_key = localStorage.getItem("api_key");
    const requestBody = {
      customer_id: Number(customer_id),
      api_key: api_key,
      academic: id ||  "cay25", 
    };
    try {
      const response = await simplePostCall(
        ApiConfig.feeStructurecatogorylist,
        JSON.stringify(requestBody)
      );
      if (response?.result && response?.data) {
        setFeeCategories(response.data);
      } else {
        setFeeCategories([]);
      }
    } catch (error) {
      setFeeCategories([]);
    } finally {
      setIsLoading(false);
    }
  };

  // ----------------------
  // VIEW FEE STRUCTURE API (NEW — SAME PATTERN AS BEFORE)
  // ----------------------
  const loadFeeStructureView = async (gradeCode) => {
    setIsLoading(true);
    try {
      const requestBody = {
        customer_id: Number(localStorage.getItem("customer_id")) || 1005,
        api_key:
          localStorage.getItem("api_key") ||
          "b9359f494e77b6589ce12dd62518c585",
        grade:gradeCode,
        academic: id || "cay25",
      };

      const response = await simplePostCall(
        ApiConfig.viewFeeStructure,
        JSON.stringify(requestBody)
      );

      if (response?.result) {
        setGradeName(response.grade_name || "");
        setAcademicName(response.academic_name || "");
        setSummary(response.summary || []);
      } else {
        // toast.error("Failed to load fee structure");
      }
    } catch (error) {
      console.error("Error fetching fee structure:", error);
      toast.error("Something went wrong while loading fee structure");
    } finally {
      setIsLoading(false);
    }
  };

  // ----------------------
  // CALL VIEW API WHEN CLASS SELECTED
  // ----------------------
useEffect(() => {
  if (selectedClass) {
    
    loadFeeStructureView(selectedClass?.class_name);
  }
}, [selectedClass]);

  // ----------------------
  // UI (UNCHANGED)
  // ----------------------
  if (selectedClass) {
    return (
      <div className="vfs-main-container">
        <ToastContainer />
        
        <div className="vfs-white-header-row">
          <h1 className="vfs-page-title">View Fee Structure</h1>
          <div className="vfs-header-actions">
            <div className="vfs-display-header-box">
              <span className="vfs-header-label">Display Header</span>
              <input type="checkbox" defaultChecked className="vfs-header-checkbox" />
            </div>
          
            <button className="FS-btn-common FS-btn-print-color" onClick={handleDownloadPDF}>
              <Printer size={16} /> Print
            </button>
        
            <button className="FS-btn-common FS-btn-edit-color">
              Edit
            </button>
  
            <button className="FS-btn-common FS-btn-delete-color" onClick={confirmDelete}>
              Delete 
            </button>
          </div>
        </div>

        <div className="vfs-inner-card">
          <table className="vfs-info-table">
            <tbody>
              <tr>
                <td className="vfs-td-label">Grade Name</td>
                <td className="vfs-td-value">
                  {gradeName || selectedClass.class_name}
                </td>
              </tr>
              <tr>
                <td className="vfs-td-label">Academic Year Name</td>
                <td className="vfs-td-value">
                  {academicName || yearID}
                </td>
              </tr>
            </tbody>
          </table>

          <div className="vfs-summary-container">
            <div className="vfs-summary-title">Summary</div>
            <div className="vfs-summary-content">
              <span className="vfs-amount-text">Annual Total Amount(₹)</span>
              <span className="vfs-amount-value">
                ₹ {summary[0]?.["annual_total_amount($)"] || selectedClass.amount.toLocaleString()}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="firstcard-container">
      <ToastContainer />
      <div className="special-header panel-white-all">
        <h4 className="page-title">Academic Year: {yearID}</h4>
        <Link to="/create-fee" className="btn btn-primary">Create</Link>
      </div>

      <div className="yc-list-body">
        <div className="row fee-struc">
          {isLoading ? (
            <div className="col-12 text-center">
              <ScaleLoader color="#F4BB44" />
              <p className="mt-2">Fetching classes for {yearID}...</p>
            </div>
          ) : feeCategories.length > 0 ? (
            feeCategories.map((item, index) => (
              <div className="col-md-12 col-lg-4 col-sm-12 mb-4" key={index}>
                <div className={`card kard${(index % 12) + 1} text-center`}>
                  <div className="card-body">
                    <h5 className="card-title"><b>{item.class_name}</b></h5>
                    <p className="card-text">Total Fee: ₹{item.amount.toLocaleString()}</p>
                    <button
                      className="btn btn-primary btn-sm"
                      onClick={() => setSelectedClass(item)}
                    >
                      <i className="bi bi-arrow-up-right-square-fill"></i> View
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12 text-center">
              <p>No data found for the year {yearID}.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
